import * as React from "react"

import * as S from "./styled"

const SectionHero = ({ children }) => <S.Hero>{children}</S.Hero>

export default SectionHero
